var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","fill":"none","viewBox":"0 0 12 12","width":"12","height":"12"}},[_c('path',{attrs:{"stroke":"#9999A9","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.4","d":"M1.2 10.8l9.6-9.6M1.2 1.2l9.6 9.6"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }